<template>
  <div class="c-box">
    <div class="c-box__left">
      <div class="c-box__picture">
        <img
          srcset="
            @/assets/images/picture-home-1.jpg     623w,
            @/assets/images/picture-home-1@2x.jpg 1246w
          "
          sizes="(max-width: 480px) 240px,
                  800px"
          src="@/assets/images/picture-home-1.jpg"
        />
      </div>
    </div>
    <div class="c-box__right">
      <div class="c-box__text">
        <p>{{ $t("surveyResult.readRecommandationsCTA") }}</p>
        <router-link
          class="btn btn-gradient"
          :to="{
            name: 'Recommendation',
            params: { querystringClean, namespace, token, id },
          }"
          v-intro="$t('surveyNamespace.introjsAmelioration')"
          v-intro-step="8"
        >
          {{ $t("surveyResult.readRecommandations") }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ReferenceBox',
  props: {
    querystringClean: String,
    namespace: String,
    token: String,
    id: String,
  },
};
</script>
